import { Row } from 'antd'
import Scheduler from 'app/components/Core/LineItem/Scheduler/Scheduler'
import KCol from 'app/components/UI-Elements/Layout/KCol'
import { useIndex } from 'app/lib/hooks/useQuery'
import useTitle from 'app/lib/hooks/useTitle'
import { PageProps } from 'app/pages/typing'
import { RecordTypeEnum } from 'app/queries'
import * as React from 'react'
import { useIntl } from 'react-intl'

const Timeline: React.FC<PageProps> = (props) => {
  useTitle(props)
  const { formatMessage } = useIntl()
  const { loading, data } = useIndex<ILineItem>(RecordTypeEnum.lineItem, {
    variables: {
      lineItemType: 'product',
      limit: 30
    }
  })

  return (
    <Row>
      <KCol card title={formatMessage({ id: 'project.scheduler.header' })} span={24}>
        <Row>
          <KCol span={24} loading={loading}>
            <Scheduler collection={data?.nodes || []} />
          </KCol>
        </Row>
      </KCol>
    </Row>
  )
}

export default Timeline
